module.exports = __webpack_public_path__ + "img/stormbanner.c31b0243.png";